'use client';

import { createContext, useContext, useState, ReactNode } from 'react';
import { useAuthContext } from '@/components/AuthProvider';
import DepositModal from './DepositModal'; 

interface ModalContextType {
  openDeposit: () => void;
  closeDeposit: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);



export function ModalProvider({ children }: { children: ReactNode }) {
  const [isDepositOpen, setIsDepositOpen] = useState(false);
  const { user } = useAuthContext(); 

  const openDeposit = () => setIsDepositOpen(true);
  const closeDeposit = () => setIsDepositOpen(false);

  return (
    <ModalContext.Provider value={{ openDeposit, closeDeposit }}>
      {children}
      
      <DepositModal 
        isOpen={isDepositOpen} 
        onClose={closeDeposit} 
        user={user} 
      />
    </ModalContext.Provider>
  );
}

export function useModal() {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
}